module.exports = __webpack_public_path__ + "img/sx.872492b5.svg";